import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAccount } from "../account/context";

declare var window: any;

export const Hotjar = () => {
  const location = useLocation();
  const { user } = useAccount();

  useEffect(() => {
    if (typeof window.hj === "function" && user) {
      window.hj("identify", user.uniqueCode);
    }
  }, [user]);

  useEffect(() => {
    if (typeof window.hj === "function") {
     window.hj("stateChange", location.pathname);
    }
  }, [location]);

  return <></>;
};